import React, { useRef, useEffect, useState } from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PhotoUploader from "components/FileUploader/PhotoUploader";
import Button from "../../../components/CustomButtons/Button";
import BucketUpload from "./BucketUpload";
import BucketUploader from "../../../components/FileUploader/BucketUploader";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from "@material-ui/core";
import CustomInputValid from "../../../components/CustomInput/CustomInputValid";
import CustomRadio from "components/CustomRadio/CustomRadio";
import { SortableContainer, SortableElement, arrayMove, SortableHandle } from "react-sortable-hoc";
import ReorderIcon from "@material-ui/icons/Reorder";
import CustomSimpleDialog from "../../../components/CustomDialog/CustomSimpleDialog";
import { getUser } from "../../../shared/authValidation";

const DragHandle = SortableHandle(() => (
  <ReorderIcon
    style={{ cursor: "grab", color: "#888", marginBottom: 8 }}
  />
));

const PropertiesFormPhotos = props => {
    const marketingOnly = getUser('CRM marketing_only');
    const [openModal, setOpenModal] = useState(null);
    const { updateDataObj, dataObj, action } = props;
    const divRef = useRef(null);
    const divRef2 = useRef(null);

    const additional_images = dataObj.additional_image_files ? JSON.parse(dataObj.additional_image_files) : [];
    const additional_website_media = dataObj.additional_website_media ? JSON.parse(dataObj.additional_website_media) : [];

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const arr = JSON.parse(dataObj.additional_website_media || "[]");
        updateDataObj(
            "additional_website_media",
            JSON.stringify(arrayMove(arr, oldIndex, newIndex))
        );
    };

    const SortableMediaItem = SortableElement(({ children }) => children);

    const SortableMediaList = SortableContainer(({ items }) => {
        const [inputVal, setInputVal] = useState('');
        const [openDeleteModal, setOpenDeleteModal] = useState(null);
        console.log('inputVal', inputVal)
        return (
        <GridContainer>
            {openDeleteModal !== null && <CustomSimpleDialog 
                no_ok_button={true}
                open={true}
                close={() => {
                    setOpenDeleteModal(null);
                }}
                content={<>
                    <h3>Are you sure?</h3>
                    <p>Do you want to remove this media file entry?</p>
                    <Button
                        className="mr-20"
                        color="rose"
                        onClick={() => {
                            const arr = JSON.parse(dataObj.additional_website_media).filter((item,xx) => {
                                if (xx === openDeleteModal) {
                                    return false;
                                }
                                return true;
                            })
                            updateDataObj('additional_website_media', JSON.stringify(arr));
                            setOpenDeleteModal(null);
                        }}
                    >REMOVE</Button>
                    <Button
                        color="white"
                        onClick={() => {
                            setOpenDeleteModal(null);
                        }}
                    >
                        CANCEL
                    </Button>
                </>}
            />}
            {openModal !== null && <CustomSimpleDialog 
                no_ok_button={true}
                open={true}
                close={() => {
                    setOpenModal(null);
                }}
                content={<>
                    <CustomInputValid 
                        label="Enter Caption/Title"
                        value={inputVal}
                        onChange={(e) => {
                            setInputVal(e.target.value);
                        }}
                        autoFocus={true}
                    />
                    <Button
                        color="rose"
                        onClick={() => {
                            const arr = JSON.parse(dataObj.additional_website_media).map((item,xx) => {
                                if (xx === openModal) {
                                    item.caption = inputVal;
                                }
                                return item;
                            })
                            updateDataObj('additional_website_media', JSON.stringify(arr));
                            setOpenModal(null);
                        }}
                    >SUBMIT</Button>
                </>}
            />}
            {items.map((aif, x) => (
        <SortableMediaItem
            key={`media-${x}`}
            index={x}
        >
            <GridItem xs={4} sm={4} md={4}>
                {props.action !== 'View' && <>
                    <DragHandle />
                    <div style={{float:'right'}}>
                        <IconButton
                            onClick={() => {
                                setOpenDeleteModal(x);
                            }}
                        >
                            <i className="fa fa-trash red-text" style={{fontSize:18}}></i>
                        </IconButton>
                    </div>
                </>}
                <div style={{ padding: 20, border: aif.file ? "1px solid black" : "1px solid #da3b2f" }}>
                            <div style={{display:'none'}}>
                                <CustomRadio
                                    label="File Type,PDF,Photo"
                                    options={["PDF", ""]}
                                    onChange={(e) => {
                                        const arr = JSON.parse(dataObj.additional_website_media).map((aiff,xx) => {
                                            if (xx === x) {
                                                aiff.file_type = e.target.value;
                                            }
                                            return aiff;
                                        })
                                        updateDataObj('additional_website_media', JSON.stringify(arr));
                                    }}
                                    value={aif.file_type === 'PDF' ? 'PDF' : ""}
                                />
                            </div>
                            
                            <div style={{marginBottom:30}}>
                                <CustomInputValid 
                                    disabled={props.action === 'View' ? true : false}
                                    value={aif.caption ? aif.caption : ''}
                                    label="Caption"
                                    onChange={(e) => {
                                        
                                    }}
                                    onClick={() => {
                                        console.log('setting inputVal',aif.caption, aif)
                                        setInputVal(aif.caption || '');
                                        setOpenModal(x);
                                    }}
                                />
                            </div>
                            <BucketUploader
                                has_alt={true}
                                disabled={props.action === 'View' ? true : false}
                                title={aif.file ? `Media #${x+1}` : ''}
                                update={(val, alt) => {
                                    const arr = JSON.parse(dataObj.additional_website_media).map((aiff,xx) => {
                                        if (xx === x) {
                                            aiff.file = val;
                                        }
                                        return aiff;
                                    })
                                    updateDataObj('additional_website_media', JSON.stringify(arr));
                                }}
                                remove={() => {
                                    const arr = JSON.parse(dataObj.additional_website_media).filter((aiff,xx) => {
                                        if (xx !== x) return true;
                                    });
                                    updateDataObj('additional_website_media', JSON.stringify(arr));
                                }}
                                the_filename={aif.file}
                                the_alt={aif.alt}
                                type="crm"
                                canEdit={props.canEdit}
                                updateNotes={props.updateNotes}
                                show_image={aif.file_type === 'PDF' ? false : true}
                                image_size_the_same={true}
                            />
                    </div>
            </GridItem>
        </SortableMediaItem>
            ))}
        </GridContainer>
        )
    });


    return <>
        <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
                <h3>Website Featured Image</h3>
                <p>* Publicly Accessible</p>
                <BucketUploader
                    disabled={props.action === 'View' ? true : false}
                    title=""
                    update={(val) => {
                        updateDataObj('website_featured_image', val, true);
                    }}
                    remove={() => {
                        updateDataObj('website_featured_image', '', true);
                    }}
                    the_filename={dataObj.website_featured_image}
                    type="crm"
                    canEdit={props.canEdit}
                    updateNotes={props.updateNotes}
                    show_image={true}
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className="boxed">
                    <h3>Additional Website Media</h3>
                    {props.action !== 'View' && <Button
                        color="primary"
                        onClick={() => {
                            let arr = dataObj.additional_website_media ? JSON.parse(dataObj.additional_website_media) : [];
                            arr.push({
                                id: crypto.randomUUID(),
                                file: '',
                                alt: ''
                            })
                            updateDataObj('additional_website_media', JSON.stringify(arr));
                            divRef2.current.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >Add</Button>}
                    {!dataObj.additional_website_media && action !== 'View'}
                        <SortableMediaList
                            items={additional_website_media}
                            onSortEnd={onSortEnd}
                            axis="xy"
                            distance={6}
                            helperClass="dragging"
                            disabled={action === "View"}
                            useDragHandle
                        />
                    {additional_website_media.length === 0 && <div><em>- None -</em></div>}
                        <div ref={divRef2}></div>
                </div>
            </GridItem>
        </GridContainer>
        <div className={marketingOnly ? "no-click lightgray-bg enclosure" : ""}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <hr />
                    <h3>Featured Image</h3>
                    <PhotoUploader 
                        disabled={props.action === 'View' ? true : false}
                        title=""
                        update={(val) => {
                            updateDataObj('featured_image_file', val, true);
                        }}
                        remove={() => {
                            updateDataObj('featured_image_file', '', true);
                        }}
                        the_filename={dataObj.featured_image_file}
                        type="crm"
                        canEdit={props.canEdit}
                        updateNotes={props.updateNotes}
                        show_image={true}
                    />
                    {(!dataObj.featured_image_file && action === 'View') && <div><em>- None -</em></div>}
                    <hr />
                    <h3>Additional Image(s)</h3>
                    {props.action !== 'View' && <Button
                        color="primary"
                        onClick={() => {
                            let arr = dataObj.additional_image_files ? JSON.parse(dataObj.additional_image_files) : [];
                            arr.push({
                                id: crypto.randomUUID(),
                                file: ''
                            })
                            updateDataObj('additional_image_files', JSON.stringify(arr));
                            divRef.current.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >Add</Button>}
                    {!dataObj.additional_images && action !== 'View'}
                    <GridContainer>
                    {additional_images.length === 0 && <div><em>- None -</em></div>}
                    {additional_images.map((aif,x) => {
                        return <GridItem xs={4} sm={4} md={4} key={`aif-${x}`}>
                                <div style={{padding:20,border:aif.file ? 'none' : '1px solid #da3b2f'}}>
                                    
                                    <PhotoUploader 
                                        disabled={props.action === 'View' ? true : false}
                                        title={aif.file ? `Photo #${x+1}` : ''}
                                        update={(val) => {
                                            const arr = JSON.parse(dataObj.additional_image_files).map((aiff,xx) => {
                                                if (xx === x) {
                                                    return {
                                                        file: val
                                                    }
                                                }
                                                return aiff;
                                            })
                                            updateDataObj('additional_image_files', JSON.stringify(arr));
                                        }}
                                        remove={() => {
                                            const arr = JSON.parse(dataObj.additional_image_files).filter((aiff,xx) => {
                                                if (xx !== x) return true;
                                            });
                                            updateDataObj('additional_image_files', JSON.stringify(arr));
                                        }}
                                        the_filename={aif.file}
                                        type="crm"
                                        canEdit={props.canEdit}
                                        updateNotes={props.updateNotes}
                                        show_image={true}
                                    />
                                </div>
                        </GridItem>
                    })}
                    <div ref={divRef}></div>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    </>
}

export default PropertiesFormPhotos;